const allowedEmail = ['ucd.ie', 'traveltechlabs.com', 'dualtron.ie'];
const budgetConfig = {
    type: 'free', // 'free', 'list'
    label: 'PO Number',
    pattern: new RegExp("^[A-Za-z0-9? ,_-]+$") // alphanumeric, spaces, dash, underscore
}
const orderConfig = {
    lastOrderTime: '16:30' // 24 hour format e.g 16:30
}
const appConfig = {
    timeout: 1000 * 60 * 15 // Idle timeout in milliseconds.
}
export {
    allowedEmail,
    budgetConfig,
    orderConfig,
    appConfig
};